import { useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import { CustomSelect } from '@/components/inputs/CustomSelect'
import { ItemSource } from '@/components/inputs/custom-select-state-observable'
import { useCustomSelectStateFromItemSource } from '@/components/inputs/item-source-hook'
import { UpdateProgressionStepDialog } from '@/features/jobs/details/components/UpdateProgressionStepDialog'
import { type UpdateProgressionStepDialogViewModel } from './UpdateProgressionStepDialogViewModel'

export interface UpdateProgressionStepDialogContainerProps {
  vm: UpdateProgressionStepDialogViewModel
}

export const UpdateProgressionStepDialogContainer = observer(
  function UpdateProgressionStepDialogContainer({
    vm,
  }: UpdateProgressionStepDialogContainerProps) {
    const { shellInfo } = useFeatures(({ shell }) => ({
      shellInfo: shell.shellInfo,
    }))

    const itemSource = useMemo(
      () =>
        ItemSource.static(vm.steps, (item, text) =>
          item.display.toLowerCase().includes(text.toLowerCase()),
        ),
      [vm.steps],
    )

    const selectProps = useCustomSelectStateFromItemSource({
      itemSource,
    })

    return (
      <UpdateProgressionStepDialog
        showing={vm.modal.showing}
        showIllustration={!shellInfo.corporateMode}
        currentStepTitle={vm.currentStepTitle}
        stepField={
          <CustomSelect
            {...selectProps}
            placeholder="Select progression step"
            multi={false}
            testId="update-job-progression-dialog-dropdown"
            value={vm.selectedStepOption}
            onChange={vm.selectProgressionStep}
            itemToString={(item) => item.display}
          />
        }
        isUpdatePending={vm.update.pending}
        isOverrideDisabled={!vm.selectedStepOption}
        onClose={vm.modal.close}
        onOverride={vm.update}
      />
    )
  },
)
